import { DiagnosticRange } from "@/constants/enums/DiagnosticRange";
import {
	GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT,
	GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT_ERROR,
	GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT_SUCCESS,
	GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART,
	GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART_ERROR,
	GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART_SUCCESS,
	RESET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT,
} from "./MainShaftParallelMisalignmentActionTypes";
import WDService from "@/services/wind/diagnostic/WindDiagnosticService";
import { SetLayoutLinesColor } from "@/components/charts/ChartStyles";
import FetchStatus from "@/constants/fetch-status/FetchStatus";

const mutations = {
	[GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT_SUCCESS]: (state, resp) =>
	{
		state.signalSettingIds = resp.signalSettingIds;
		state.operatingRange = resp.operatingRange;
		state.status = FetchStatus.Loaded;
	},
	[GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT_ERROR]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error;
	},
	[RESET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT]: (state) =>
	{
		state.status = FetchStatus.Init;
		state.operatingRange = DiagnosticRange.undefined;
	},
	[GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART_SUCCESS]: (state, resp) =>
	{
		resp.parallelMisalignmentMainShaftChartData.forEach(chart =>
		{
			chart.concernFrequencies = resp.concernFrequencies;
			chart.concernOrders = resp.concernOrders;
		});
		const orderChartData     = WDService.CreateChart(resp.parallelMisalignmentMainShaftChartData, true);
		const frequencyChartData = WDService.CreateChart(resp.parallelMisalignmentMainShaftChartData, false);
	
		state.orderChartData = orderChartData;
		state.orderLayout = SetLayoutLinesColor(WDService.OrderLayoutModel(), resp.isDarkMode);
		state.orderLayout.shapes = WDService.CreateShapes(orderChartData[0].frequencies);
		state.orderLayout.annotations = WDService.CreateAnnotationText(orderChartData[0].frequencies, resp.isDarkMode,
			"MAIN SHAFT");
	
		state.frequencyChartData = frequencyChartData;
		state.frequencyLayout = SetLayoutLinesColor(WDService.FrequencyLayoutModel(), resp.isDarkMode);
		state.frequencyLayout.shapes = WDService.CreateShapes(frequencyChartData[0].frequencies);
		state.frequencyLayout.annotations = WDService.CreateAnnotationText(frequencyChartData[0].frequencies,
			resp.isDarkMode, "MAIN SHAFT");
	
		state.status = FetchStatus.Loaded;
	},
	[GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART_ERROR]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error;
	},
};

export default { mutations };
